import { Typography } from '@mui/material';

interface IProps {
  title: string;
  value?: string;
  children?: JSX.Element;
}

function TitleValueField({ title, value, children }: IProps) {
  return (
    <div>
      <Typography variant='caption' sx={{ color: 'text.disabled' }}>
        {title}:
      </Typography>
      <Typography variant='body1'>{value}</Typography>
      {children}
    </div>
  );
}

export default TitleValueField;
